import { FormField, PubSub, StateManager, StringToPrimitive } from '../../utils'

let $manualAddress1 = null
let $searchAddress1 = null
let $manualAddress2 = null
let $searchAddress2 = null
let $equalAddresses = null
let $unequalAddresses = null
let $multipleAddresses = null
let $showSearchAddress1 = null
let $showSearchAddress2 = null


let $limitedCompany = null
let $registeredCompany = null

let $addressEqualityCheck = null
let $registeredAddress = null
let $registeredAddressFields = null
let $billingAddress = null
let $billingAddressDisplay = null
let $billingAddressFields = null
let $deliveryAddressDisplay = null
let $deliveryAddressRadio = null

let _isEditMode = false
let _isUkSite = true
let _state = undefined

const STATE_ATTR = 'data-state-toggle'
const STATE_ID = 'step2'

const CLICK_ACTION = {
  EDIT_MANUAL_ADDRESS1: 'editManualAddress1',
  EDIT_SEARCH_ADDRESS1: 'editSearchAddress1',
  EDIT_MANUAL_ADDRESS2: 'editManualAddress2',
  EDIT_SEARCH_ADDRESS2: 'editSearchAddress2',
  ADD_NEW_BILLING_ADDRESS: 'addNewBillingAddress',
  FORM_SUBMIT: 'formSubmit'
}

const FIELD_NAME = {
  ADDRESS_EQUALITY: 'Form.IsBillingAddressSameAsRegisteredAddress',
  DELIVERY_ADDRESS: 'Form.DeliverToBillingAddress',
  BUSINESS_TYPE: 'Form.BusinessTypeId'
}

const DELIVERY_ADRRESS_SELECTION = {
  REGISTERED: 'False',
  BILLING: 'True'
}


const init = () => {
  if (window.isStep2 == undefined) return

  const { isPreloaded, isEditMode } = window

  _isEditMode = isEditMode || isPreloaded
  if (window.isUkSite != undefined) _isUkSite = window.isUkSite 

  setupDomElements()

  const billingAddress = getAddressFieldValues($billingAddressFields)
  const registeredAddress = getAddressFieldValues($registeredAddressFields)
  const registeredEqualsBilling = registeredAddress.length > 0 && billingAddress.length > 0 && registeredAddress == billingAddress

  const _isBillingAddress = $deliveryAddressRadio != null
    ? StringToPrimitive.convert(FormField($deliveryAddressRadio).valueOf.radioGroup())
    : false

  const store = {
    addressEditing: {
      manualAddress1: false,
      manualAddress2: false
    },
    billingAddress: {
      content: billingAddress,
      isRegisteredAddress: true
    },
    registeredAddress: {
      content: registeredAddress
    },
    deliveryAddress: {
      content: _isBillingAddress ? billingAddress : registeredAddress,
      isBillingAddress: _isBillingAddress
    },
    companyType: {
      isLimited: true
    }
  }

  if (_isEditMode) store.billingAddress.isRegisteredAddress = registeredEqualsBilling

  _state = StateManager(STATE_ID, store)

  mapAddressFields()
  addEventListeners()
  updateView()
}


const setupDomElements = () => {
  $manualAddress1 = [...document.querySelectorAll(`[${STATE_ATTR}='manualAddress1']`)]
  $searchAddress1 = [...document.querySelectorAll(`[${STATE_ATTR}='searchAddress1']`)]
  $manualAddress2 = [...document.querySelectorAll(`[${STATE_ATTR}='manualAddress2']`)]
  $searchAddress2 = [...document.querySelectorAll(`[${STATE_ATTR}='searchAddress2']`)]
  $equalAddresses = [...document.querySelectorAll(`[${STATE_ATTR}='equalAddresses']`)]
  $unequalAddresses = [...document.querySelectorAll(`[${STATE_ATTR}='unequalAddresses']`)]
  $multipleAddresses = [...document.querySelectorAll(`[${STATE_ATTR}='multipleAddresses']`)]
  $showSearchAddress1 = [...document.querySelectorAll(`[${STATE_ATTR}='showSearchAddress1']`)]
  $showSearchAddress2 = [...document.querySelectorAll(`[${STATE_ATTR}='showSearchAddress2']`)]

  $limitedCompany = [...document.querySelectorAll(`[${STATE_ATTR}='limitedCompany']`)]
  $registeredCompany = [...document.querySelectorAll(`[${STATE_ATTR}='registeredCompany']`)]

  $addressEqualityCheck = document.querySelector(`[name='${FIELD_NAME.ADDRESS_EQUALITY}']`)
  $registeredAddress = document.querySelector('#registeredAddress')
  $registeredAddressFields = [...$registeredAddress.querySelectorAll('input, select')]
  $billingAddressDisplay = document.querySelector('#billingAddressDisplay')
  $billingAddress = document.querySelector('#billingAddress')
  $billingAddressFields = [...$billingAddress.querySelectorAll('input, select')]
  $deliveryAddressDisplay = document.querySelector('#deliveryAddressDisplay')
  $deliveryAddressRadio = document.querySelector(`[name='${FIELD_NAME.DELIVERY_ADDRESS}']`)
}


const onChange = e => {
  const $el = e.target
  if (!$el) return

  const formField = FormField($el)
  const { valueOf } = formField
  const isCustomDropDown = $el.hasAttribute('data-option-name')

  if ($el.name == FIELD_NAME.ADDRESS_EQUALITY) {

    const addressContent = $el.checked ? _state.get().registeredAddress.content : ''
    if ($el.checked == false) clearBillingAddressFields()

    _state.set('billingAddress', { isRegisteredAddress: $el.checked, content: addressContent })

    if ($el.checked) {
      copyRegisteredAddressToBilling()
      _state.set('deliveryAddress', { content: addressContent })
    }
  }

  if ($el.name == FIELD_NAME.DELIVERY_ADDRESS) {
    const addressContent = valueOf.radioGroup() == DELIVERY_ADRRESS_SELECTION.REGISTERED
      ? _state.get().registeredAddress.content
      : _state.get().billingAddress.content
    _state.set('deliveryAddress', { content: addressContent })
  }

  if (formField.typeIs.select() && $el.name == FIELD_NAME.BUSINESS_TYPE) {
    setCompanyType(formField.valueOf.select())
  }

  if (isCustomDropDown && $el.dataset.optionName == FIELD_NAME.BUSINESS_TYPE) {
    setCompanyType($el.innerText)
  }
}

const setCompanyType = string => {
  _state.set('companyType', { isLimited: /(?:limited company)$|^(?:other)$/ig.test(string) })
}


const copyRegisteredAddressToBilling = () => {

  $registeredAddressFields.forEach($field => {
    const mappedId = $field.getAttribute('mapped-field')

    $billingAddressFields.forEach($billingField => {
      if ($billingField.id == mappedId) $billingField.value = $field.value
    })
  })
}


const onClick = e => {
  const $el = e.target

  const action = $el.getAttribute('action')

  if (!$el || action == null) return

  // Remove edit flag so as to enable toggling
  _isEditMode = false

  if (action == CLICK_ACTION.EDIT_SEARCH_ADDRESS1) {
    _state.set('addressEditing', { manualAddress1: false })
  }

  if (action == CLICK_ACTION.EDIT_MANUAL_ADDRESS1) {
    _state.set('addressEditing', { manualAddress1: true })
  }

  if (action == CLICK_ACTION.EDIT_SEARCH_ADDRESS2) {
    _state.set('addressEditing', { manualAddress2: false })
  }

  if (action == CLICK_ACTION.EDIT_MANUAL_ADDRESS2) {
    _state.set('addressEditing', { manualAddress2: true })
  }

  if (action == CLICK_ACTION.ADD_NEW_BILLING_ADDRESS) {
    $addressEqualityCheck.checked = false
    clearBillingAddressFields()
    _state.set('billingAddress', { isRegisteredAddress: false, content: '' })
  }

  if (action == CLICK_ACTION.FORM_SUBMIT) {
    if (hasInvalidFields($billingAddressFields)) {
      _state.set('billingAddress', { isRegisteredAddress: false })
      _state.set('addressEditing', { manualAddress2: true })
    }
    if (hasInvalidFields($registeredAddressFields)) _state.set('addressEditing', { manualAddress1: true })
  }
}

const billingAndRegisteredAreEqual = () => {
  const { registeredAddress, billingAddress } = _state.get()
  return registeredAddress.content.length > 0 && billingAddress.content.length > 0 && billingAddress.isRegisteredAddress
}

const updateView = data => {
  if (data != undefined && data.stateId != STATE_ID) return

  const state = _state.get()
  const { manualAddress1, manualAddress2 } = state.addressEditing
  const { deliveryAddress, billingAddress, registeredAddress, companyType } = state
  const uniqueAddresses = billingAddress.content != registeredAddress.content
    && registeredAddress.content.length > 0 && billingAddress.content.length > 0
  const hasMultipleAddresses = billingAddress.isRegisteredAddress == false && uniqueAddresses

  $searchAddress1.forEach($el => toggleVisibility(_isUkSite == false || _isEditMode || manualAddress1, $el))
  $manualAddress1.forEach($el => toggleVisibility(_isUkSite && (_isEditMode || manualAddress1) == false, $el))
  $searchAddress2.forEach($el => toggleVisibility(_isUkSite == false || _isEditMode || manualAddress2, $el))
  $manualAddress2.forEach($el => toggleVisibility(_isUkSite && (_isEditMode || manualAddress2) == false, $el))
 
  $showSearchAddress1.forEach($el => toggleVisibility(_isUkSite == false || (_isEditMode || manualAddress1 == false), $el))
  $showSearchAddress2.forEach($el => toggleVisibility(_isUkSite == false || (_isEditMode || manualAddress2 == false), $el))

  $equalAddresses.forEach($el => toggleVisibility(billingAddress.isRegisteredAddress == false, $el))
  $unequalAddresses.forEach($el => toggleVisibility(billingAddress.isRegisteredAddress, $el))
  $multipleAddresses.forEach($el => toggleVisibility(hasMultipleAddresses == false, $el))

  $limitedCompany.forEach($el => toggleVisibility(companyType.isLimited == false, $el))
  $registeredCompany.forEach($el => toggleVisibility(companyType.isLimited, $el))

  if (_isEditMode) $addressEqualityCheck.checked = billingAndRegisteredAreEqual()
  if (_isEditMode == false) $billingAddressDisplay.innerHTML = billingAddress.content

  if (billingAndRegisteredAreEqual()) $billingAddressDisplay.innerHTML = billingAddress.content

  if ($deliveryAddressDisplay != null) $deliveryAddressDisplay.innerHTML = deliveryAddress.content
}

const toggleVisibility = (condition, $el) => {
  $el.style.display = condition ? 'none' : 'inherit'
}

const mapAddressFields = () => {
  $registeredAddressFields.forEach($field =>
    $field.setAttribute('mapped-field', $field.id.replace('Registered', 'Billing')))
}


const registeredAddressChange = $field => {
  if ($field == null || hasInvalidFields($registeredAddressFields)) return
  const addressContent = getAddressFieldValues($registeredAddressFields)

  _state.set('registeredAddress', { content: addressContent })
  _state.set('deliveryAddress', { content: addressContent })
}


const billingAddressChange = $field => {
  if ($field == null || hasInvalidFields($billingAddressFields)) return

  const state = _state.get()
  const addressContent = getAddressFieldValues($billingAddressFields)
  const addressesAreEqual = addressContent == state.registeredAddress.content

  _state.set('billingAddress', { isRegisteredAddress: addressesAreEqual, content: addressContent })

  if (addressContent.length > 0)
    _state.set('deliveryAddress', { content: addressContent })
}


/**
 * Given a collection of fields, will check each fields validity status
 * @param {Array} $fields
 * @returns {Boolean} whether any invalid fields exist
 */
const hasInvalidFields = $fields => {
  let _hasInvalidFields = false

  for (const $field of $fields) {
    const data = $field.dataset
    const value = $field.value
    const regex = data.valRegexPattern

    // Check if this is a required field
    // Uses jQuery validate HTML properties to make assertions
    if (data.hasOwnProperty('fieldRequired')) {
      // Assert the field value is invalid
      if (!value || Boolean(regex) && RegExp(regex).test(value) == false) {
        _hasInvalidFields =  true
        break
      }
    }
  }

  return _hasInvalidFields
}

const getAddressFieldValues = $fields => {
  const address = $fields.map($field => {
    const formField = FormField($field)

    return formField.typeIs.select()
      ? formField.valueOf.select()
      : $field.value
  })

  return address.filter(item => Boolean(item)).join(',<br/>')
}

const addressLookupChange = addressId => {
  if (addressId == 'registered') $registeredAddressFields.forEach($field => registeredAddressChange($field))
  if (addressId == 'billing') $billingAddressFields.forEach($field => billingAddressChange($field))
}

const onRegisteredInput = e => registeredAddressChange(e.target)

/**
 * Special method to alow custom dropdowns to udate state on change
 * @param {Object} e - Event data passed in by custom dropdown
 */
const onAddressDropdownChange = e => {
  if (e.target == undefined) return

  const name = e.target.dataset.optionName
  const $field = document.querySelector(`[name="${name}"]`)

  if (name == 'Form.RegisteredAddress.CountyId') registeredAddressChange($field)
  if (name == 'Form.BillingAddress.CountyId') billingAddressChange($field)
}

const onBillingInput = e => billingAddressChange(e.target)

const clearBillingAddressFields = () => {
    $billingAddressFields.forEach($field => $field.value = '')
    PubSub.publish('customdropdown:update')
}


const addEventListeners = () => {
  const $form = document.querySelector('form')

  $form.addEventListener('change', onChange)
  $form.addEventListener('click', onClick)

  $registeredAddress.addEventListener('change', onRegisteredInput)
  $billingAddress.addEventListener('change', onBillingInput)

  PubSub.subscribe('customdropdown:change', onAddressDropdownChange)
  PubSub.subscribe('customdropdown:change', onChange)
  PubSub.subscribe('addresslookup:updated', addressLookupChange)
  PubSub.subscribe('state:change', updateView)
}

const Step2InteractionHandler = { init }
export default Step2InteractionHandler



// WEBPACK FOOTER //
// ./js/self-serve/core/Step2InteractionHandler.js